<!-- Wrapping everything up in this if so we remove all this from once the PATIENT takes action -->
@if (visible()) {
    <p-dialog
        [style]="{ 'max-width': '600px', width: '100%' }"
        header="Access Request"
        [visible]="true"
        [resizable]="false"
        [closeOnEscape]="false"
        [modal]="true"
        [closable]="false"
        appendTo="body">
        <p-messages [value]="info()" [enableService]="false" [closable]="false" />

        @for (request of promptsPending(); track $index) {
            <p-panel styleClass="my-2">
                <p>
                    <b> {{ request.requestDate | date: "dd/MM/yyyy HH:mm" }}</b
                    >: <b> {{ request.issuedByUser }}</b
                    >, on behalf of <b>{{ request.requestingOrganization }}</b> (the requesting organisation), is requesting access to your
                    ORB Data
                </p>

                <p class="m-0">Granting access will allow viewing of your data from the following organisations:</p>
                <ul class="m-0 pl-4">
                    @for (orgToBeGranted of request.organizationsToBeGranted; track $index) {
                        <li>{{ orgToBeGranted }}</li>
                    }
                </ul>
            </p-panel>
        }

        @if (promptsPending().length > 1) {
            <p class="text-sm">
                <b><em>Note:</em></b>
                There are multiple active requests, clicking the "Grant Access" button below will grant access to all the requesting
                Organisations at once.
            </p>
        }

        <ng-template pTemplate="footer">
            <input type="hidden" />
            <div class="flex align-items-center justify-content-between">
                <button
                    pButton
                    [loading]="grantingOrMarking()"
                    class="m-button-primary"
                    icon="pi pi-check"
                    type="button"
                    label="Grant Access"
                    (click)="grantAccess()"></button>

                <div>
                    <button type="button" pButton icon="pi pi-cog" label="Manage" class="p-button-primary" (click)="manage()"></button>

                    <button
                        type="button"
                        [loading]="grantingOrMarking()"
                        pButton
                        icon="pi pi-times"
                        label="I'll Review Later"
                        class="p-button-outlined"
                        (click)="reviewLater()"></button>
                </div>
            </div>
        </ng-template>
    </p-dialog>
}
